import { MATRIX } from '../../../constants/questionTypes';

function getMatrixResponseArray(response) {
  if (!response) return [];
  return Array.isArray(response) ? response.filter(Boolean) : [response];
}

export function isMatrixResponseComplete(element, response, { optionCount, isQuestionRequired = true } = {}) {
  if (!element || element.question?.style !== MATRIX) return true;

  const responseArray = getMatrixResponseArray(response);
  const matrixType = element.question.extra?.matrix_question_type;

  if (matrixType === 'maxdiff') {
    const requiredCount = optionCount ?? element.question.options?.length ?? 2;
    return responseArray.length >= requiredCount;
  }

  const statements = (element.question.statements || []).filter((statement) => statement.isVisible !== false);
  if (!statements.length) return true;

  const answeredStatementIds = new Set(
    responseArray
      .filter((item) => item && typeof item === 'object' && item.statementId)
      .map((item) => item.statementId),
  );

  // Check statement-level required validation
  const requiredStatements = statements.filter((statement) => statement.isRequired === true);

  if (requiredStatements.length > 0) {
    const allRequiredAnswered = requiredStatements.every((stmt) => answeredStatementIds.has(stmt.id));
    if (!allRequiredAnswered) {
      return false;
    }
  }

  // If the question itself is required, all statements must be answered
  if (isQuestionRequired) {
    return statements.every((statement) => answeredStatementIds.has(statement.id));
  }

  return true;
}
